<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { getNotificationsContext } from '@client/components/notifications';
  import { Spinner } from '@client/components/spinner';

  import { DomainsService } from '@client/services/domains';

  import BillingForm from './billing-form.svelte';

  const { addNotification } = getNotificationsContext();

  export let domain = {};
  export let show = false;
  export let updating = false;

  let MAXIO_DEFAULT_BILLING_ID = 9876;
  let error = '';

  let config = {
    domainname: domain.domainname,
    billingid: domain?.domainsettings?.billing_customer_id || MAXIO_DEFAULT_BILLING_ID,
    ybillingid: domain?.domainsettings?.billing_id,
    authcode: ''
  };

  const resetModal = () => {
    show = false;

    config = {
      domainname: '',
      billingid: MAXIO_DEFAULT_BILLING_ID,
      ybillingid: '',
      authcode: ''
    };
  };

  const onUpdate = async () => {
    if (updating) {
      return;
    }

    updating = true;

    error = '';

    const response = await DomainsService.updateBillingId(config);

    updating = false;

    if (response.status >= 400) {
      error = $format('label.FAILURE.BILLING_ID_UPDATE', {
        values: {
          message: response.message
        }
      });

      return;
    }

    addNotification({
      text: $format('label.SUCCESS.BILLING_ID_UPDATE'),
      type: 'success',
      autohide: 2500,
      position: 'top-right'
    });

    domain = {
      ...domain,
      domainname: config.domainname,
      domainsettings: {
        ...domain.domainsettings,
        billing_id: config.ybillingid,
        billing_customer_id: config.billingid
      }
    };

    resetModal();
  };

  const onKeyUp = (event) => {
    error = '';

    if (event.key === 'Enter') {
      onUpdate();
    }
  };

  $: show === false && resetModal();
  $: isDisabled =
    !config.domainname ||
    !config.billingid ||
    !config.ybillingid ||
    !config.authcode ||
    (config.ybillingid === domain?.domainsettings?.billing_id &&
      config.billingid === domain?.domainsettings?.billing_customer_id);
</script>

<Modal bind:isOpen={show} size="sm">
  <div class="update-billingid-modal modal--content">
    <button class="close" on:click={() => (show = !show)}>
      <Icon name="x" />
    </button>

    <div>
      <h1>{$format('label.UPDATE_BILLING_ID')}</h1>

      <BillingForm bind:config {error} {updating} {onKeyUp} />
    </div>

    <div class="footer-actions">
      <Button color="primary" disabled={isDisabled} on:click={onUpdate}>
        {#if updating}
          <Spinner show inline />
        {:else}
          {$format('label.UPDATE')}
        {/if}
      </Button>
    </div>
  </div>
</Modal>

<style lang="scss" src="./billing.scss"></style>
